export default __webpack_public_path__ + "static/media/late.a7525c03.png";